import { api } from './api'

export async function checkEmail(email) {
  const response = await api.post('/auth/check-email', { email })
  return response.data
}

export async function requestOtp(email) {
  const response = await api.post('/auth/login/request-otp', { email })
  return response.data
}

export async function verifyOtp(email, otp) {
  const response = await api.post('/auth/login/verify-otp', { email, otp })
  return response.data
}

export async function register(email, name) {
  const response = await api.post('/auth/register', { email, name })
  return response.data
}

export async function verifyMagicToken(token) {
  const response = await api.get(`/auth/magic-login?token=${encodeURIComponent(token)}`)
  return response.data
}
